module.exports = __webpack_public_path__ + "img/111.d095d511.jpg";